import { proxy } from "valtio";

/**
 * 一屏引导触发条件里「非路由、非 store」的两路信号（fe-spec §3.4.1）：
 *
 * - `paywallOpenCount`：onboarding 首付费墙打开中（`openOnboardingPaywall` 进入 +1、
 *   结果 settle -1）。用计数而不是布尔，防并发两次打开时先关的那次把标记提前清掉（R3）。
 * - `storageVersion`：本地预约 / 兑现写入后自增，让订阅方重读 localStorage。
 *
 * 用 valtio proxy 而不是裸模块变量：Host 需要在标记变化时**重新评估**（§3.4.1
 * 「条件不满足时保持 pending，下次满足再弹」）。
 */
export const onepageGuideSignals = proxy({
  paywallOpenCount: 0,
  storageVersion: 0,
});

export function setOnboardingPaywallOpen(open: boolean): void {
  if (open) {
    onepageGuideSignals.paywallOpenCount += 1;
    return;
  }
  onepageGuideSignals.paywallOpenCount = Math.max(
    0,
    onepageGuideSignals.paywallOpenCount - 1,
  );
}

export function isOnboardingPaywallOpen(): boolean {
  return onepageGuideSignals.paywallOpenCount > 0;
}

export function bumpOnepageGuideStorageVersion(): void {
  onepageGuideSignals.storageVersion += 1;
}

/** 测试复位 */
export function resetOnepageGuideSignals(): void {
  onepageGuideSignals.paywallOpenCount = 0;
  onepageGuideSignals.storageVersion = 0;
}
